<template>
  <b-modal
    ref="importModal"
    :visible="visible"
    title="Importar BC"
    @hide="handleModalHide"
    :ok-disabled="!selectedFile || loading"
    :cancel-disabled="loading"
    no-close-on-backdrop
    :no-close-on-esc="loading"
  >
    <div class="my-2">
      <h5 class="mb-3">Selecciona un archivo Excel (.xlsx)</h5>
      
      <div v-if="!loading">
        <b-form-group label="Archivo:" label-for="file-input">
          <input
            id="file-input"
            type="file"
            accept=".xlsx"
            :disabled="loading"
            @change="onFileSelected"
            class="form-control"
          />
          <small v-if="selectedFile" class="d-block mt-2">
            Archivo seleccionado: <strong>{{ selectedFile.name }}</strong>
          </small>
        </b-form-group>
      </div>

      <div v-if="loading" class="mt-3 text-center">
        <b-spinner label="Procesando..." class="mb-3" />
        <p class="mt-3"><strong>Importando archivo...</strong></p>
        <b-progress :value="uploadProgress" animated class="mt-3" />
        <small class="d-block mt-2">Progreso: {{ uploadProgress }}%</small>
      </div>
    </div>

    <template v-slot:modal-footer>
      <button
        type="button"
        class="btn btn-secondary"
        :disabled="loading"
        @click="closeModal"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        :disabled="!selectedFile || loading"
        @click="handleImport"
      >
        <b-spinner small class="mr-2" v-if="loading" />
        {{ loading ? 'Importando...' : 'Importar' }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ImportBCModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedFile: null,
      loading: false,
      uploadProgress: 0,
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.resetModal()
      }
    },
  },
  methods: {
    onFileSelected(event) {
      const files = event.target.files
      if (files && files.length > 0) {
        this.selectedFile = files[0]
        console.log('Archivo seleccionado:', this.selectedFile)
      }
    },
    async handleImport() {
      if (!this.selectedFile) {
        this.$toast.error('Por favor selecciona un archivo')
        return
      }

      // Validar que sea un archivo .xlsx
      if (!this.selectedFile.type.includes('spreadsheet') && !this.selectedFile.name.endsWith('.xlsx')) {
        this.$toast.error('Por favor selecciona un archivo en formato .xlsx')
        return
      }

      this.loading = true
      this.uploadProgress = 0

      try {
        const formData = new FormData()
        formData.append('file', this.selectedFile)

        console.log('FormData keys:', Array.from(formData.keys()))
        console.log('File to upload:', this.selectedFile)

        const response = await Vue.prototype.$http.post(
          `/${this.resource}/import-bc`,
          formData,
          {
            transformRequest: [data => data],
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              )
            },
          }
        )

        this.$toast.success('Archivo importado exitosamente')
        this.$emit('import-success', response.data)
        this.resetModal()
        this.closeModal()
      } catch (error) {
        console.error('Error al importar archivo:', error)
        console.error('Response error:', error?.response?.data)
        const errorMessage = error?.response?.data?.message || error?.response?.data?.error || 'Error al importar el archivo. Por favor inténtelo de nuevo.'
        this.$toast.error(errorMessage)
        this.loading = false
      }
    },
    resetModal() {
      this.selectedFile = null
      this.loading = false
      this.uploadProgress = 0
    },
    closeModal() {
      this.$refs.importModal.hide()
    },
    handleModalHide() {
      if (!this.loading) {
        this.$emit('close')
        this.resetModal()
      }
    },
  },
}
</script>

<style scoped>
</style>
